import { put, throwIfError } from 'utils/api';

export const postDeductions = async (
  orgId,
  propertyId,
  affordableQualificationId,
  applicantId,
  data,
  options,
) => {
  const response = await put(
    `/portal/${orgId}/${propertyId}/affordable-qualifications/${affordableQualificationId}/applicants/${applicantId}/affordable-qualification-checklist`,
    { ...data },
    options,
  );

  return throwIfError(response);
};
